"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledChip = exports.SearchIcon = exports.Label = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _constants = require("./constants");
const Label = exports.Label = (0, _mui.styled)(_mui.Typography)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  textTransform: 'none',
  verticalAlign: 'baseline'
});
const StyledChip = exports.StyledChip = (0, _mui.styled)(_mui.Chip)(({
  theme
}) => ({
  height: _constants.CHIP_HEIGHT,
  padding: theme.spacing(1, 3),
  gap: theme.spacing(1),
  borderRadius: theme.spacing(2),
  [`.${_mui.chipClasses.icon}`]: {
    margin: 0
  },
  [`.${_mui.chipClasses.label}`]: {
    padding: 0
  }
}));
const SearchIcon = exports.SearchIcon = (0, _mui.styled)(_icons.Search)({
  height: '24px',
  width: '24px'
});
